import { companyProfileSchema } from './company-profile';

import type { CompanyProfile } from './company-profile';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../shared/source/validating-http-fetcher';
import type Result from 'true-myth/result';

export type GenerateCompanyPriorities = () => Promise<Result<CompanyProfile, unknown>>;

const timeout = 60_000;

export const createGenerateCompanyPriorities = (dependencies: {
    readonly validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl;
}): GenerateCompanyPriorities => {
    const { validatingCobrainerApiFetcher } = dependencies;

    return () => {
        return validatingCobrainerApiFetcher.post(companyProfileSchema, {
            pathname: `/company-profile/generate/priorities`,
            requestOptions: {
                timeout,
            },
        });
    };
};
